import React from 'react'
import RegisterForm from './forms/RegisterForm'
import './Auth.css'
import signup from '../../assets/signup.jpg'

export default function RegisterScreen() {
    return (
        <div>
           <div className="container mb-3">
               <div className="row">
                   <div className="col-lg-6 col-md-12 col-sm-12">
                      <RegisterForm/>
               


                   </div>
                   <div className="col-lg-6 col-md-12 col-sm-12">
                             
          
                       <img style={{ width  : '100%' }} src={signup} />
                   </div>
               </div>
           </div>
        </div>
    )
}
